export default __webpack_public_path__ + "static/media/2.e07f9081.jpg";